module.exports = __webpack_public_path__ + "static/18-7613d88efbf98872ab6a0a006127e631.jpg";